<template>
  <div>
    <!-- 卡片试图 -->
    <el-card class="box-card" v-loading="loading">
      <!-- 添加和搜索 -->
      <el-row :gutter="35">
        <el-form :model="searchQuery" ref="form" :inline="true" style="padding-left: 30px">
          <el-form-item :label="$t('clientmanage.table.merchantNo')" prop="merchantNo">
            <el-input size="mini" v-model="searchQuery.merchantNo" />
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.agentAccount')" prop="agentAcct">
            <el-input size="mini" v-model="searchQuery.agentAcct" />
          </el-form-item>
          <!-- 代付查询地址 -->
          <el-form-item :label="$t('clientmanage.table.payoutQueryUrl')" prop="payoutQueryUrl">
            <el-input size="mini" v-model="searchQuery.payoutQueryUrl" clearable />
          </el-form-item>
          <!-- 代付查询状态 -->
          <el-form-item :label="$t('clientmanage.table.payoutQueryStatus')">
            <el-select
              clearable
              v-model="searchQuery.payoutQueryStatus"
            >
              <el-option
                v-for="item in payoutQueryStatus"
                :label="item.label"
                :value="item.value"
                :key="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.merchantType')">
            <el-select
              v-model="searchQuery.merchantType"
              :placeholder="$t('clientmanage.addDialog.selectType')"
            >
              <el-option
                v-for="item in selectType"
                :label="item.label"
                :value="item.value"
                :key="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="getClient()">{{ $t('btns.search') }}</el-button>
            <el-button size="mini" type="danger" @click="$refs.form.resetFields()">{{
              $t('btns.empty')
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>

      <virtual-scroll
      :data="clientList"
      :item-size="62"
      key-prop="index"
      @change="(renderData) => virtualList = renderData">
      <!-- 用户列表区域 -->
      <el-table
        :data="virtualList"
        stripe
        class="table"
        ref="table"
        row-key="index"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
  >
        <el-table-column prop="index" label="#"></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantName')"
          prop="merchantName"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantPhone')"
          prop="phone"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantNo')"
          prop="merchantNo"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.agentAccount')"
          prop="agentAcct"
        ></el-table-column>
        <!-- <el-table-column
          :label="$t('clientmanage.table.GeneralAgent')"
          prop="masterAcct"></el-table-column> -->
        <el-table-column :label="$t('clientmanage.table.merchantModel')" prop="merchantModel">
          <template slot-scope="scope">
            <div v-if="scope.row.merchantModel == 1">
              {{ $t('clientmanage.addDialog.optionModtext1') }}
            </div>
            <div v-if="scope.row.merchantModel == 2">
              {{ $t('clientmanage.addDialog.optionModtext2') }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          :label="$t('clientmanage.table.merchantResources')"
          prop="merchantResources">
          <template slot-scope="scope">
            <div v-if="scope.row.merchantResources == 0">
              {{ $t("clientmanage.addDialog.optionRestext1") }}
            </div>
            <div v-if="scope.row.merchantResources == 1">
              {{ $t("clientmanage.addDialog.optionRestext2") }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('clientmanage.table.merchantType')" prop="merchantType">
          <template slot-scope="scope">
            <div v-if="scope.row.merchantType == 0">
              {{ $t('clientmanage.addDialog.optionTypetext1') }}
            </div>
            <div v-if="scope.row.merchantType == 1">
              {{ $t('clientmanage.addDialog.optionTypetext2') }}
            </div>
            <div v-if="scope.row.merchantType == 2">
              {{ $t('clientmanage.addDialog.optionTypetext3') }}
            </div>
            <div v-if="scope.row.merchantType == 3">
              {{ $t('clientmanage.addDialog.optionTypetext4') }}
            </div>
            <div v-if="scope.row.merchantType == 4">
              {{ $t('clientmanage.addDialog.optionTypetext5') }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="menuStatus" :label="$t('clientmanage.table.autoTransIn')">
          <template slot-scope="scope">
            <el-switch
              class="demo"
              v-model="scope.row.autoStatus"
              :active-value="0"
              :inactive-value="1"
              inactive-color="#F56C6C"
              active-color="#00A854"
              @change="merchantStatusChange(scope.row, 'autoStatus')"
            >
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('clientmanage.addDialog.payoutType')" prop="payoutType">
          <template slot-scope="scope">
            <div v-if="scope.row.payoutType == 0">
              {{ $t('clientmanage.addDialog.normalPayout') }}
            </div>
            <div v-if="scope.row.payoutType == 1">
              {{ $t('clientmanage.addDialog.specialPayout') }}
            </div>
          </template>
        </el-table-column>
  
        <el-table-column :label="$t('clientmanage.table.operaTion')" width="200">
          <template slot-scope="scope">
            <!-- 查看商户详情 -->
            <el-tooltip
              :key="`${scope.row.id}-2`"
              v-if="permission.indexOf('merchantdetails:manager') > -1"
              effect="dark"
              :content="$t('clientmanage.table.checkmessage')"
              placement="top"
              enterable
            >
              <el-button
                type="primary"
                icon="el-icon-zoom-in"
                @click="checkClient(scope.row.merchantNo)"
                size="medium"
                circle
              ></el-button>
            </el-tooltip>
  
          </template>
        </el-table-column>
        <el-table-column :label="$t('device.createDate')" prop="createTime"> </el-table-column>
      </el-table>
    </virtual-scroll>


      <v-pagination
        v-model="pagination"
        :size="pagination.size"
        :total="tableData.rows"
        @update="getClient"
      />
    </el-card>

    <el-dialog width="90%" :visible.sync="isDetail">
      <merchantdetails :isBack="false" :key="newKey"></merchantdetails>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import merchantApi from '@/api/merchant';
import base from '@/mixin/base.js';
import merchantdetails from './merchantdetails.vue';



export default {
  mixins: [base],
  components: {
    merchantdetails
  },
  name: 'Clientmanage',
  data() {
    return {
      virtualList:[],
      newKey: Date.parse(new Date()),
      isDetail: false,
      tableData: {},
      agents: [],
      /* ---------------------------------- 搜索表单 ---------------------------------- */
      searchQuery: {
        //获取商户的参数
        merchantNo: '',
        agentAcct: '',
        merchantType: null,
        payoutQueryUrl:'',
        payoutQueryStatus:null,
      },
      pagination: {
        current: 1,
        size: 500,
        no: 1
      },
      loading: false, 
    
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info || {}
    }),
    ...mapGetters(['permission']),
    canOperate() {
      return (
        this.permission.indexOf('rest:paypass') > -1 ||
        this.permission.indexOf('merchant:restPayPassword') > -1
      );
    },
    userType() {
      return this.info.userType;
    },
    clientList() {
      return this.tableData.list?this.tableData.list.map((item,index)=>({index:(index+1),...item})) : [];
    },

    selectType() {
      /**
       * usertype === 0 管理员用户，可以添加商户类型有商户与代理
       */
      return [
        {
          label: this.$t('clientmanage.addDialog.optionTypetext3'),
          value: 2
        },
        {
          label: this.$t('clientmanage.addDialog.optionTypetext2'),
          value: 1
        }
      ];
    },
    payoutQueryStatus () {
      return [
        {
          label: this.$t('status.close'),
          value: 1
        },
        {
          label: this.$t('status.open'),
          value: 0
        },

      ]
    }
  },


  mounted() {
    this.getClient();
  },
  methods: {
    async getClient() {
      this.loading = true;
      const { data } = await merchantApi.getPage({
        data: this.searchQuery,
        params: this.pagination
      });
      if (data && data.code === 200) {
        this.tableData = data.data;
        this.loading = false;
      } else {
        this.$message.error(this.$t('status.error'));
        this.loading = false;
      }
    },



  
    async checkClient(merchantNo) {
      const { data } = await this.$http.get(`/merchant/getMerchant`,{ params: { merchantNo } });
      if (data && data.code === 200) {
        this.$store.commit('SET_CLIENTDATA', data.data);
        // 跳转详情页
        // this.$router.push({ name: 'merchantdetails' });
        this.isDetail = true;
        this.newKey = Date.parse(new Date());
      } else {
        return this.$message.error(data.msg);
      }
    },


      

  }
};
</script>

<style scoped>
.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/clientmanage/index.vue